<template>
    <div class="slider">
        <div class="g_restrict">
            <heading :level="3">{{ config.previousEditions }}</heading>

            <swiper-wrapper
                v-if="!$breakpoint.isS"
                class="items"
                ref="swiper"
                :options="options"
                @init="onInit"
            >
                <template #slides>
                    <div
                        v-for="edition in reverseTeasers"
                        :key="edition.number"
                        class="swiper-slide"
                    >
                        <slider-editions-card
                            :current="current"
                            :edition="edition"
                        />
                    </div>
                </template>
            </swiper-wrapper>

            <div class="grid" v-else>
                <slider-editions-card
                    v-for="edition in teasers"
                    :current="current"
                    :key="edition.number"
                    :edition="edition"
                />
            </div>
        </div>
    </div>
</template>

<script>
import Heading from 'gvue/src/core/Heading'
import SliderEditionsCard from '@/components/slider/SliderEditionsCard'
import SwiperWrapper from '@/components/common/SwiperWrapper'

export default {
    name: 'SliderEditions',
    components: {
        Heading,
        SliderEditionsCard,
        SwiperWrapper
    },
    props: {
        current: {
            type: String,
            required: true
        },
        teasers: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            options: {
                slidesPerView: 2,
                spaceBetween: 30,
                simulateTouch: false,
                navigation: {}
            }
        }
    },
    computed: {
        config() {
            return this.$json.config
        },
        reverseTeasers() {
            return [...this.teasers].reverse()
        }
    },
    watch: {
        current: {
            handler() {
                if (!this.$breakpoint.isS) {
                    this.slide()
                }
            },
            immediate: true
        }
    },
    methods: {
        onInit() {
            this.slide()
        },
        slide() {
            this.$nextTick(() => {
                const { swiper } = this.$refs && this.$refs.swiper
                if (swiper) {
                    const index =
                        this.reverseTeasers.length - parseInt(this.current)
                    swiper.slideTo(index)
                }
            })
        }
    }
}
</script>

<style lang="sass" scoped>
@import ~nespresso-bi/utilities
@import ~nespresso-bi/brand/variables
@import ~gvue/src/core/Zone/sass/zone/zone

.swiper-container
    overflow: visible

::v-deep
    .swiper-button-prev,
    .swiper-button-next
        height: ($gap * 3.5)
        width: ($gap * 3.5)
        margin-top: ($gap * -1.75)
        border-radius: 0

    .swiper-button-prev
        left: ($gap * -1)

    .swiper-button-next
        right: ($gap * -1)

    .swiper-container
        --swiper-navigation-size: 2em

.g_h3
    margin: 0
    padding: ($gap * 3.25) ($gap * 2.5) ($gap * 2.25)
    font-weight: 500
    letter-spacing: 0.167em

.grid
    display: flex
    flex-direction: column-reverse

+mobile
    .g_h3
        max-width: 15em

    .g
        .g_restrict
            padding: 0
            max-width: 100%

+desktop
    .slider
        padding: ($gap * 5) 0
        margin-top: ($gap * 5)
        background-color: $color_background

    .g_h3
        margin-bottom: ($gap * 2)
        padding: 0
        font-size: 1.5em
</style>
